"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { langLoaded } from "Actions/ApplicationActions";

var MessagesClass =
/*#__PURE__*/
function () {
  function MessagesClass() {
    _classCallCheck(this, MessagesClass);
  }

  _createClass(MessagesClass, [{
    key: "init",
    value: function init(lang) {
      var _this = this;

      this._msg = null;
      return new Promise(function (resolve) {
        switch (lang) {
          case 'ru':
            import(
            /* webpackChunkName: "ru" */
            './lang/ru').then(function (_ref) {
              var Messages = _ref.default;
              _this._msg = Messages;
              langLoaded();
              resolve();
            });
            break;

          case 'en':
            import(
            /* webpackChunkName: "en" */
            './lang/en').then(function (_ref2) {
              var Messages = _ref2.default;
              _this._msg = Messages;
              langLoaded();
              resolve();
            });
            break;
        }
      });
    }
  }, {
    key: "Success",
    get: function get() {
      return this._msg.Success;
    }
  }, {
    key: "Errors",
    get: function get() {
      return this._msg.Errors;
    }
  }, {
    key: "Warning",
    get: function get() {
      return this._msg.Warning;
    }
  }, {
    key: "Confirm",
    get: function get() {
      return this._msg.Confirm;
    }
  }, {
    key: "Message",
    get: function get() {
      return this._msg.Message;
    }
  }, {
    key: "Controls",
    get: function get() {
      return this._msg.Controls;
    }
  }, {
    key: "System",
    get: function get() {
      return this._msg.System;
    }
  }]);

  return MessagesClass;
}();

export var Messages = new MessagesClass();